
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.navigationInitialized = false;
        this.currentMediaIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.handlePrevious = this.showPreviousMedia.bind(this);
        this.handleNext = this.showNextMedia.bind(this);
        this.handleKeydown = this.onNavigationKeydown.bind(this);
        this.handleTouchStart = this.onTouchStart.bind(this);
        this.handleTouchEnd = this.onTouchEnd.bind(this);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.initializeNavigation();
        this.updateNavigation();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      initializeNavigation() {
        if (this.navigationInitialized) return;

        const dialog = this.querySelector('.product-media-modal__dialog');

        this.mediaContainer = this.querySelector(
          '.product-media-modal__content'
        );

        if (!dialog || !this.mediaContainer) return;

        this.mediaItems = Array.from(this.mediaContainer.children).filter(
          (element) => element.hasAttribute('data-media-id')
        );

        if (this.mediaItems.length < 2) return;

        const navigation = document.createElement('div');
        navigation.className = 'mayall-modal-navigation';
        navigation.setAttribute('aria-label', 'Navigation des photos');

        this.previousButton = document.createElement('button');
        this.previousButton.type = 'button';
        this.previousButton.className = 'mayall-modal-arrow';
        this.previousButton.setAttribute('aria-label', 'Photo précédente');
        this.previousButton.textContent = '‹';

        this.counter = document.createElement('span');
        this.counter.className = 'mayall-modal-counter';
        this.counter.setAttribute('aria-live', 'polite');

        this.nextButton = document.createElement('button');
        this.nextButton.type = 'button';
        this.nextButton.className = 'mayall-modal-arrow';
        this.nextButton.setAttribute('aria-label', 'Photo suivante');
        this.nextButton.textContent = '›';

        navigation.append(
          this.previousButton,
          this.counter,
          this.nextButton
        );

        dialog.appendChild(navigation);

        this.previousButton.addEventListener(
          'click',
          this.handlePrevious
        );

        this.nextButton.addEventListener(
          'click',
          this.handleNext
        );

        this.addEventListener('keydown', this.handleKeydown);

        this.mediaContainer.addEventListener(
          'touchstart',
          this.handleTouchStart,
          { passive: true }
        );

        this.mediaContainer.addEventListener(
          'touchend',
          this.handleTouchEnd,
          { passive: true }
        );

        this.navigationInitialized = true;
      }

      updateNavigation() {
        if (!this.mediaItems || !this.mediaItems.length) return;

        const activeIndex = this.mediaItems.findIndex((item) =>
          item.classList.contains('active')
        );

        if (activeIndex !== -1) {
          this.currentMediaIndex = activeIndex;
        }

        if (this.counter) {
          this.counter.textContent =
            `${this.currentMediaIndex + 1} / ${this.mediaItems.length}`;
        }
      }

      navigateToMedia(index) {
        if (!this.mediaItems || !this.mediaItems.length) return;

        const total = this.mediaItems.length;

        this.currentMediaIndex = (index + total) % total;

        const target = this.mediaItems[this.currentMediaIndex];

        // Précharge les images voisines.
        [
          this.currentMediaIndex - 1,
          this.currentMediaIndex,
          this.currentMediaIndex + 1,
        ].forEach((i) => {
          const item = this.mediaItems[(i + total) % total];

          if (!item) return;

          item.querySelectorAll('img').forEach((img) => {
            img.loading = 'eager';
          });
        });

        this.mediaItems.forEach((item) => {
          item.classList.toggle('active', item === target);
        });

        const container = this.mediaContainer;

        if (container) {
          const left =
            target.offsetLeft -
            (container.clientWidth - target.clientWidth) / 2;

          container.scrollTo({
            left: Math.max(0, left),
            behavior: 'auto',
          });
        }

        if (target.nodeName === 'DEFERRED-MEDIA') {
          target.loadContent();
        }

        this.updateNavigation();
      }

      showPreviousMedia() {
        this.navigateToMedia(this.currentMediaIndex - 1);
      }

      showNextMedia() {
        this.navigateToMedia(this.currentMediaIndex + 1);
      }

      onNavigationKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousMedia();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextMedia();
        }
      }

      onTouchStart(event) {
        if (!event.touches || event.touches.length !== 1) return;

        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      }

      onTouchEnd(event) {
        if (!event.changedTouches || event.changedTouches.length !== 1) {
          return;
        }

        const deltaX =
          event.changedTouches[0].clientX - this.touchStartX;

        const deltaY =
          event.changedTouches[0].clientY - this.touchStartY;

        if (
          Math.abs(deltaX) < 50 ||
          Math.abs(deltaX) < Math.abs(deltaY)
        ) {
          return;
        }

        if (deltaX < 0) {
          this.showNextMedia();
        } else {
          this.showPreviousMedia();
        }
      }
    }
  );
}
